// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyC8X6Yg0NULOzyG8Z93WKxabJvLix9nPw4",
    authDomain: "trosten-efcb3.firebaseapp.com",
    databaseURL: "https://trosten-efcb3.firebaseio.com",
    projectId: "trosten-efcb3",
    storageBucket: "trosten-efcb3.appspot.com",
    messagingSenderId: "955110386976"
  },
  host : 'operacion.trosten.com',
  // TR-22: DSN de Sentry (proyecto trosten-web-app, org trosten). Vacío = desactivado. Este es el archivo que usa producción:
  // deploy-tools compila con `ng build` sin --env=prod. Sólo se inicializa en environment.host.
  sentryDsn: 'https://ed911cb69a8784f8f5a2a4278828876e@o4511870494048256.ingest.us.sentry.io/4512295660552192',
  // TR-22: métricas de uso/tiempos; sólo se envían cuando el host es operacion.trosten.com.
  metricas: {
    url: 'https://operacion.trosten.com/corp-school/php/metricas/lote.php'
  },
  zonasRojasJsonUrl: 'https://storage.googleapis.com/trosten-efcb3.appspot.com/zonas-rojas/latest.json'

};




// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/environments/environment.ts